const getMonth = (date: Date): string => {
  const month = date.getMonth() + 1;
  return month > 9 ? month.toString() : `0${month.toString()}`;
};

const getDate = (date: Date): string => {
  const day = date.getDate();
  return day > 9 ? day.toString() : `0${day.toString()}`;
};

export default (date: Date): string => (!date
  ? undefined
  : `${getDate(date)}.${getMonth(date)}.${date.getFullYear()}`);
